import React, { useCallback } from "react";

export const Timeline = ({
  data = [],
  className = "",
  selectedIdx = 0,
  hideChapterNames = false,
  onChapterChange = () => {},
}) => {
  const chapterClickCallback = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      onChapterChange(Number(e.target.dataset.chapterIdx));
    },
    [onChapterChange]
  );

  return (
    <div
      className={`timeline block-font h5 col-12 flex flex-row flex-wrap ${className}`}
    >
      {!hideChapterNames && (
        <div className="flex flex-row justify-around items-center col-12">
          {data.map((chapter, chapterIdx) => (
            <div
              key={`corporate-timeline-chapter-title-${chapterIdx}`}
              data-chapter-idx={chapterIdx}
              onClick={chapterClickCallback}
              className={`chapter ${
                selectedIdx === chapterIdx ? "chapter--selected" : ""
              } pointer center`}
            >
              {chapter.title}
            </div>
          ))}
        </div>
      )}
      <div className="axis flex flex-row justify-around mt2 mb1 col-12">
        {data.map((_, chapterIdx) => (
          <div
            className=""
            key={`corporate-timeline-chapter-marker-${chapterIdx}`}
          >
            <div
              className={`marker ${
                selectedIdx === chapterIdx ? `marker--selected` : ""
              } marker--up`}
            />
            <div
              className={`marker ${
                selectedIdx === chapterIdx ? `marker--selected` : ""
              } marker--down`}
            />
          </div>
        ))}
      </div>
      <div className="flex flex-row justify-around col-12">
        {data.map((chapter, chapterIdx) => (
          <div
            key={`corporate-timeline-chapter-date-${chapterIdx}`}
            data-chapter-idx={chapterIdx}
            onClick={chapterClickCallback}
            className={`chapter ${
              selectedIdx === chapterIdx ? "chapter--selected" : ""
            } pointer center`}
          >
            {chapter.date}
          </div>
        ))}
      </div>
    </div>
  );
};
